import { defineMessage } from '../internal-messaging';
const sendMessage = defineMessage('ct-link/send-message', payload => payload);
export const linkOperations = {
  sendMessage
};